module.exports = __webpack_public_path__ + "img/dropdown.cb311879.svg";